import { i18n } from "@/plugins/i18n"

const router = [
  {
    path: "embedding",
    name: "embedding",
    component: () => import("@/views/Embedding/Embedding.vue"),
    meta: {
      pageTitle: i18n.t("players.list_title"),
      rule: "owner",
    },
    children: [
      {
        path: "players",
        component: () => import("@/views/Embedding/Players/Players.vue"),
        children: [
          {
            path: "",
            name: "players",
            component: () => import("@/views/Embedding/Players/PlayerList.vue"),
            meta: {
              pageTitle: i18n.t("players.list_title"),
              rule: "owner",
            },
          },
          {
            path: "create",
            component: () => import("@/views/Embedding/Players/PlayerCreate"),
            name: "player.create",
            props: true,
            meta: {
              pageTitle: i18n.t("players.add_title"),
              parent: "players",
              rule: "owner",
            },
          },
          {
            path: ":playerKey",
            component: () => import("@/views/Embedding/Players/Player.vue"),
            name: "player",
            props: true,
            meta: {
              pageTitle: i18n.t("players.settings_title"),
              parent: "players",
              rule: "owner",
            },
          },
        ],
      },
    ],
  },
]

export default router
